'use client'

import type { FC, ReactNode } from 'react'
import { WagmiStoreVersionCheck } from 'src/lib/wagmi/components/wagmi-store-version-check'
import { getWagmiConfig, getWagmiInitialState } from 'src/lib/wagmi/config'
import { WalletProvider } from 'src/lib/wallet'
import { WagmiProvider as _WagmiProvider } from 'wagmi'

export const WagmiProvider: FC<{
  children: ReactNode
  cookie?: string | null
}> = ({ children, cookie }) => {
  const initialState = getWagmiInitialState(cookie)

  return (
    <_WagmiProvider config={getWagmiConfig()} initialState={initialState}>
      <div className="h-full w-full [&>div]:h-full">
        <WagmiStoreVersionCheck>{children}</WagmiStoreVersionCheck>
      </div>
    </_WagmiProvider>
  )
}
